import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';
import { getIsBackgroundsPopupOpen } from '../DeviationBackground/redux/selectors';
const mapStateToProps = (state, ownProps)=>({
        isAnyDialogOpen: getIsBackgroundsPopupOpen(state),
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=ActionBar.container.js.map